<template>
  <section class="lms-container">
    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>
      <div class="modules-content">
        <div class="module-item" data-id="1" data-module-lessons="23">
          <div class="title-content custom-grid">
            <h3 class="module-title" style="font-size: 14px;">Calendário</h3>

            <!-- <span
              class="module-progress loading-placeholder"
              style="display: block; width: 250px !important;"
             
            >
              <div class="control-group"  v-if="userType == 1">
                <select v-model="selectedmodule" id="course" class="form-control">
                  <option value="undefined" disabled selected>Selecione um módulo</option>
                  <option v-for="m in modules" v-bind:key="m.id" v-bind:value="m.id">{{m.name}}</option>
                </select>
              </div>
            </span>
            <a
              v-on:click="getEvents()"
              style="margin-top:auto; margin-left: 85px !important"
              class="form-control btn btn-default-lms"
               v-if="userType == 1"
            >
              Buscar Eventos
              <i class="fa fa-search"></i>
            </a> -->
            <a
              v-on:click="addNewEvent = true"
              style="margin-top:auto; margin-left: 85px !important"
              class="form-control btn btn-default-lms"
               v-if="userType == 2"
            >
              Criar Evento
              <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <div v-if="addNewEvent" style="padding-left:0px;padding-right:0px;" class="modules-content">
          <div class="module-item">
            <div
              class="title-content"
              style="grid-gap:0;grid-template-columns:30rem 35rem 25rem 25rem"
            >
              <div style="margin-right:15px;" class="module-title control-group">
                <label class="control-label" for="name">Descrição</label>

                <div class="controls">
                  <input id="name" v-model="newEvent.name" type="text" class="form-control" />
                </div>
              </div>

              <div style="margin-right:15px;" class="control-group">
                <label class="control-label" for="name">Data</label>

                <div class="input-group">
                 
                  <input type="datetime-local" v-model="newEvent.date" class="form-control" />
                   <i class="fa fa-calendar input-group-addon" aria-hidden="true"></i>
                </div>
              </div>

              <div style="margin-right:15px;" class="module-title control-group">
                <label class="control-label" for="name">Módulo</label>

                <div class="controls">
                  <select v-model="newEvent.module_id" id="teacher" class="form-control">
                    <option value="0" disabled selected>Selecione um módulo</option>
                    <option v-for="m in modules" v-bind:key="m.id" v-bind:value="m.id">{{m.name}}</option>
                  </select>
                </div>
              </div>

              <!-- <h3 class="module-title">Módulo</h3> -->
              <a
                v-on:click="addEvent()"
                v-if="!loading"
                style="margin-top:auto;"
                class="form-control btn btn-default-lms"
              >
                Salvar
                <i class="fa fa-save"></i>
              </a>

              <div>
                <span class="module-progress loading-placeholder"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="module-item" v-if="events.length > 0">
          <li
            class="lesson-subtitle"
            style="grid-template-columns: 30rem 15rem 30rem 15rem 20rem !important;"
          >
            <span class="lesson-title">Evento</span>
            <span class="lesson-title">Data</span>
            <span class="lesson-title">Módulo</span>
            <span class="lesson-title" v-if="userType == 1">Professor</span>
            <span class="lesson-title" v-if="userType == 2"></span>
            <span class="lesson-title" v-if="userType == 2"></span>
          </li>

          <ul class="lessons-list">
            <li
              v-for="(data,index) in events"
              :key="index"
              class="lesson"
              data-id="64"
              data-videos="1"
              style="grid-template-columns: 30rem 15rem 30rem 15rem 20rem !important;"
            >
              <span class="lesson-title">{{data.name}}</span>
              <span class="lesson-title">{{data.date | formatEventDate}}</span>
              <span class="lesson-title">{{data.moduleName}}</span>
              <span class="lesson-title" v-if="userType == 1">{{data.userName}}</span>
              <lms-button v-if="userType == 2" @click="editEvent(data)" class="lesson-option" v-show="!loading">Editar</lms-button>
              <lms-button  v-if="userType == 2" @click="removeEvent(data)" class="lesson-option" v-show="!loading">Remover</lms-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userType: this.$store.getters.user.type,
      selectedStudent: {},
      selectedmodule: {},
      modules: [],
      students: [],
      loading: false,
      addNewEvent: false,
      newEvent: {},
      events: []
    };
  },
  computed: {},
  components: {},
  methods: {
    // getStudentData() {
    //   this.$emit("getStudentData", this.selectedStudent, this.selectedCourse);
    // },
    getModules() {
      const path = this.$global.endpoint + "/module/getbyteacher";
      axios
        .post(path)
        .then(res => {
          this.modules = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    searchStudents() {
      const path = this.$global.endpoint + "/user/getbymodule";
      axios
        .post(path, {
          module_id: this.selectedmodule
        })
        .then(res => {
          this.students = res.data.students;

          if (this.students.length > 0) {
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    addEvent(){
      console.log("mandou salvar", this.newEvent);
      this.loading = true;
      const path = this.$global.endpoint + "/module/saveEvent";
      axios
        .post(path, {
          event: this.newEvent
        })
        .then(res => {
          this.loading = false;
          this.getEvents();
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    editEvent(data){
      this.addNewEvent = true;
      this.newEvent = data;
    },
    getEvents(){
      this.loading = true;
      const path = this.$global.endpoint + "/module/getEvents";
      axios
        .post(path, {
          module_id: this.selectedmodule.id
        })
        .then(res => {
          this.loading = false;
          this.events = res.data.events;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
     removeEvent(data){
      this.loading = true;
      const path = this.$global.endpoint + "/module/removeEvent";
      axios
        .post(path, {
          event_id: data.id
        })
        .then(res => {
          this.loading = false;
          this.getEvents();
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    }
  },
  created() {
    this.newEvent.module_id = "0";
    this.getModules();
    this.getEvents();
  }
};
</script>
